import { getContrastColor } from 'featureSliced/shared/utils/getContrastColor'
import styled from 'styled-components'

type ProfileOptionType = {
  disabled?: boolean
}

type NumberTextType = {
  isGreen?: boolean
}

const MainTextColors = {
  PENDING: '#4A90E2',
  IN_PREPARATION: '#4A90E2',
  PREPARED: '#4A90E2',
  TAKEN: '#34CB9E',
  NOT_PAID: '#434343',
  0: '#434343',
  1: '#34CB9E',
}

export const ProfileOption = styled('div')<ProfileOptionType>`
  border: ${({ theme }) => `1px solid ${theme.ItemsBorders}`};
  border-radius: 5px;
  height: 50px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.FontColor};

  background-color: ${({ theme, disabled }) =>
    disabled ? '#e1e1e1' : theme.ItemsBackGround};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  p {
    margin-left: 10px;
  }
`

export const Page = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 55px;
  color: #434343;
  text-align: center;
  margin-top: 0;
  color: ${({ theme }) => theme.FontColor};
`

// Edit

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  position: relative;
  div:not(:last-child) {
    margin-right: 5px;
  }
`

export const EyeImage = styled.img`
  position: absolute;
  z-index: 1;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
`

export const Error = styled.p`
  color: #c60008;
  font-size: 12px;
  margin-bottom: 20px;
`

// Card

export const CardMargin = styled.div`
  margin-top: 35px;
`

export const CardItem = styled.p`
  display: flex;
  justify-content: center;
  font-size: 16px;
  column-gap: 10px;
`

export const CardTitle = styled(CardItem)`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.FontColor};
`

export const RefillButtonContainer = styled.div`
  margin-top: 15px;
  /* margin-bottom: -10px; */
  display: flex;
  gap: 15px;
`

// Orders

export const OrdersButtonsContainer = styled.div`
  margin-top: -25px;
  padding-bottom: 10px;
  padding-top: 5px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 55px 45px;
  grid-gap: 0 25px;
  width: calc(100vw - 40px);
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  z-index: 1;
  background-color: ${({ theme }) => theme.MainBackGround};
`

export const NoOrders = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.colour};
  text-align: center;
  width: 100%;
  top: 50px;
`

export const OrderItem = styled.div`
  margin-bottom: 5px;
  border: ${({ theme }) => `1px solid ${theme.ItemsBorders}`};
  background-color: ${({ theme }) => theme.ItemsBackGround};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

export const OrderHeader = styled.div`
  height: 70px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
`

export const OrderProducts = styled.div`
  width: 100%;
`

export const OrderProduct = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 75px;
  grid-template-rows: 30px 30px;
`

export const OrderProductTitle = styled.p`
  line-height: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: ${({ theme }) => theme.FontColor};
`

export const OrderProductTotal = styled.p`
  line-height: 16px;
  color: #c3c3c3;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size: 14px;
`

export const OrderProductImage = styled.img`
  grid-row: 1 / -1;
  grid-column: 1 / 2;
  max-width: 100%;
  object-fit: contain;
  border-radius: 50%;
  padding: 5px;
`

export const BranchPrice = styled.div`
  height: 40px;
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  width: 100%;
`

export const PriceContainer = styled.div`
  color: ${({ theme }) => theme.FontColor};

  font-size: 14px;
  white-space: nowrap;
`

export const PriceContainerItem = styled(PriceContainer)`
  width: 100%;
  height: 100%;
  padding-right: 10px;

  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const NumberDate = styled.div`
  width: 110px;
  height: 40px;
  margin: 0 10px;
  border-right: 1px solid #cdcdcd;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
`

export const MainText = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.FontColor};
`

export const NumberText = styled(MainText)<NumberTextType>`
  color: ${({ theme, isGreen }) => {
    if (isGreen) {
      return 'green'
    } else {
      return theme.FontColor
    }
  }};
`

export const SubText = styled.p`
  font-size: 11px;
  line-height: 15px;
  color: ${({ theme }) => theme.FontColor};
`

export const Chevron = styled.img`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translate(0, -50%);
`

// Refill card

export const RefillCard = styled.div`
  color: ${({ theme }) => theme.FontColor};
  height: 100%;
  min-height: calc(35vh - 50px - 20px - 25px);

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  & > p {
    margin: 10px 0;
    width: 100%;
    text-align: right;
  }
  & button {
    height: 50px !important;
  }
`

export const RadioContainer = styled.div`
  display: flex;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.FontColor};
  input {
    margin-right: 10px;
  }
`

export const ResultText = styled.p`
  color: ${({ theme }) => theme.colour};
`

/////// Card layout

type CardProps = {
  isIOS?: boolean
  isBonuses?: boolean
  isCartNumber?: boolean
}

const darkenHex = (hex: string, factor: number): string => {
  const cleanHex = hex.replace('#', '')
  if (cleanHex.length !== 6) return hex // fallback if not a valid full hex

  const r = parseInt(cleanHex.slice(0, 2), 16)
  const g = parseInt(cleanHex.slice(2, 4), 16)
  const b = parseInt(cleanHex.slice(4, 6), 16)

  const darken = (channel: number) =>
    Math.max(0, Math.min(255, Math.round(channel * (1 - factor))))

  const toHex = (val: number) => val.toString(16).padStart(2, '0')

  return `#${toHex(darken(r))}${toHex(darken(g))}${toHex(darken(b))}`
}

export const CardContainer = styled('div')<CardProps>`
  background: ${({ theme }) => theme.colour};
  padding: 0 10px;
  border-radius: 10px;
  color: ${({ theme }) => getContrastColor(theme.colour)};
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif;
  border: ${({ theme }) => `1px solid ${darkenHex(theme.colour, 0.2)}`};

  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  aspect-ratio: 5 / 6.5;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 25px;
  z-index: 2;
`

export const CardMainDataContainer = styled('div')<CardProps>`
  display: grid;
  grid-template-rows: 40px 110px 55px 40px;
`

export const CardHeader = styled('div')<CardProps>`
  grid-row: 1 / 2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: ${({ isIOS }) => (isIOS ? 'unset' : '1px solid #fff')};
  padding-top: 5px;
`

export const CardHoldersName = styled('div')<CardProps>`
  grid-row: 2 / 3;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  /* text-transform: uppercase; */
  font-size: 35px;
  color: ${({ theme }) => theme.fontColorCA || theme.FontColor};
  /* text-transform: ${({ isIOS }) => (isIOS ? 'uppercase' : 'unset')}; */
  margin-top: 15px;
  p {
    line-height: 55px;
  }
`

export const CardSaldoPointContainer = styled('div')<CardProps>`
  grid-row: ${({ isIOS }) => (isIOS ? '4 / 5' : '3 / 4')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CompanyLogo = styled('img')`
  height: 40px;
  object-fit: contain;
`

export const CardSaldoPointItem = styled('div')<CardProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: ${({ isCartNumber }) =>
    isCartNumber ? 'flex-end' : 'flex-start'};

  text-transform: ${({ isIOS }) => (isIOS ? 'uppercase' : 'unset')};
  color: ${({ theme }) => theme.fontColorCA || theme.FontColor};
  & p:first-child {
    font-size: 10px;
    font-weight: 800;
    line-height: normal;
  }
  & p:nth-child(2) {
    font-size: ${({ isCartNumber }) => (isCartNumber ? '20px' : '22px')};

    font-weight: ${({ isCartNumber }) => (isCartNumber ? '600' : '400')};
  }
`

export const CardQrCodeContainer = styled('div')<CardProps>`
  aspect-ratio: 1.5;
  height: 160px;
  width: 220px;
  align-self: center;

  border-radius: ${({ isIOS }) => (isIOS ? '5px' : '10px')};
  overflow: hidden;

  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-items: ${({ isIOS }) => (isIOS ? 'flex-start' : 'center')};
  justify-self: center;
  margin-bottom: 10px;
  img {
    max-height: 100%;
    max-width: 100%;
  }
`
